export class RestoreBackup {

  constructor(
    public backupId?: string,
    public customerId?: string,
    public restoreMedia?: boolean
  ) {
  }
}
